document.querySelectorAll('.steps').forEach((section) => {
    const items = section.querySelectorAll('.steps__item');
    const images = section.querySelectorAll('.steps__gallery-img');

    if (!items.length || !images.length) return;

    const setActive = (index) => {
        items.forEach((item) => item.classList.toggle('is-active', item.dataset.step === String(index)));
        images.forEach((img) => img.classList.toggle('is-active', img.dataset.step === String(index)));
    };

    items.forEach((item) => {
        item.addEventListener('mouseenter', () => setActive(item.dataset.step));
        item.addEventListener('click', () => setActive(item.dataset.step));
        item.addEventListener('focus', () => setActive(item.dataset.step));
    });
});
